import styled from 'styled-components';

export const DashboardIframe = styled.iframe.attrs({
  frameBorder: '0',
})`
  height: 100%;
`;
